import React from 'react';
import { DEFAULT_USER_AGREEMENT_DOCUMENT } from '../legal/userAgreement';

const parseAgreementContent = (content = '') => {
  const blocks = [];
  let paragraphLines = [];
  let listItems = [];

  const flushParagraph = () => {
    if (!paragraphLines.length) return;
    blocks.push({ type: 'paragraph', text: paragraphLines.join(' ').trim() });
    paragraphLines = [];
  };

  const flushList = () => {
    if (!listItems.length) return;
    blocks.push({ type: 'list', items: listItems });
    listItems = [];
  };

  String(content || '')
    .split(/\r?\n/)
    .forEach((rawLine) => {
      const line = rawLine.trim();
      if (!line) {
        flushParagraph();
        flushList();
        return;
      }

      if (line.startsWith('## ')) {
        flushParagraph();
        flushList();
        blocks.push({ type: 'heading', text: line.replace(/^##\s+/, '').trim() });
        return;
      }

      if (line.startsWith('- ')) {
        flushParagraph();
        listItems.push(line.replace(/^-\s+/, '').trim());
        return;
      }

      flushList();
      paragraphLines.push(line);
    });

  flushParagraph();
  flushList();
  return blocks;
};

const UserAgreementDocument = ({ agreement = DEFAULT_USER_AGREEMENT_DOCUMENT, className = '' }) => {
  const document = {
    ...DEFAULT_USER_AGREEMENT_DOCUMENT,
    ...(agreement || {})
  };
  const blocks = parseAgreementContent(document.content);

  return (
    <article className={`select-text rounded-2xl border border-gray-200 bg-white p-5 shadow-sm dark:border-gray-800 dark:bg-gray-900 sm:p-7 ${className}`}>
      <header className="border-b border-gray-200 pb-5 dark:border-gray-800">
        <div className="mb-3 inline-flex rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700 dark:bg-blue-950/35 dark:text-blue-300">
          Редакция {document.version}
        </div>
        <h1 className="text-2xl font-bold leading-tight text-gray-950 dark:text-gray-50 sm:text-3xl">
          {document.title}
        </h1>
        {document.subtitle && (
          <p className="mt-2 text-sm font-medium text-gray-600 dark:text-gray-300">
            {document.subtitle}
          </p>
        )}
      </header>

      <div className="space-y-4 pt-6">
        {blocks.map((block, index) => {
          if (block.type === 'heading') {
            return (
              <h2 key={`${block.type}-${index}`} className="pt-3 text-base font-semibold text-gray-950 dark:text-gray-50">
                {block.text}
              </h2>
            );
          }

          if (block.type === 'list') {
            return (
              <ul key={`${block.type}-${index}`} className="space-y-2 pl-5 text-sm leading-6 text-gray-700 dark:text-gray-200">
                {block.items.map((item) => (
                  <li key={item} className="list-disc">
                    {item}
                  </li>
                ))}
              </ul>
            );
          }

          return (
            <p key={`${block.type}-${index}`} className="text-sm leading-6 text-gray-700 dark:text-gray-200">
              {block.text}
            </p>
          );
        })}
      </div>
    </article>
  );
};

export default UserAgreementDocument;
